import pa from '@/internationalization/trans/chefs/pa/pa.json';
export default {
  trans: pa,
};
